import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTabsModule } from '@angular/material/tabs';
import { InvoiceDetailsComponent } from './invoice-details.component';
import { InvoiceDetailsService } from './invoice-details.service';

@NgModule({
  declarations: [
    InvoiceDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatTabsModule
  ],
  exports: [
    InvoiceDetailsComponent
  ],
  providers: [
    InvoiceDetailsService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class InvoiceDetailsModule { }
